import React, {useState} from 'react';
import {Switch} from '@headlessui/react';

import {cx} from '../util';

export default function Toggle({
  defaultOn = false, rightLabel, leftLabel, onChange, disabled = false,
}) {
  const [on, setOn] = useState(defaultOn);
  const handleChange = (value) => {
    if (onChange) onChange(value);
    setOn(value);
  };

  const getToggleBg = () => {
    if (disabled) return 'bg-gray-100';
    if (on) return 'bg-indigo-600';
    return 'bg-gray-300';
  };

  return (
    <Switch.Group as="div" className="flex items-center">
      {leftLabel && (
        <Switch.Label as="span" className="mr-3 font-medium text-gray-700">
          {leftLabel}
        </Switch.Label>
      )}
      <Switch
        checked={on}
        onChange={handleChange}
        disabled={disabled}
        className={cx(
          getToggleBg(),
          'relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500',
        )}
      >
        <span
          aria-hidden="true"
          className={cx(
            on ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
          )}
        />
      </Switch>
      {rightLabel && (
        <Switch.Label as="span" className="ml-3 font-medium text-gray-700">
          {rightLabel}
        </Switch.Label>
      )}
    </Switch.Group>
  );
}

export const ShortToggle = ({
  defaultOn = false, onChange, disabled = false,
}) => {
  const [on, setOn] = useState(defaultOn);
  const handleChange = (value) => {
    if (onChange) onChange(value);
    setOn(value);
  };

  const getToggleBg = () => {
    if (disabled) return 'bg-gray-100';
    if (on) return 'bg-indigo-600';
    return 'bg-gray-300';
  };

  return (
    <Switch
      checked={on}
      onChange={handleChange}
      className="shrink-0 group relative rounded-full inline-flex items-center justify-center h-5 w-10 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
      <span className="sr-only">Use setting</span>
      <span aria-hidden="true" className="pointer-events-none absolute bg-white w-full h-full rounded-md" />
      <span
        aria-hidden="true"
        className={cx(
          getToggleBg(),
          'pointer-events-none absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200',
        )}
      />
      <span
        aria-hidden="true"
        className={cx(
          on ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow transform ring-0 transition-transform ease-in-out duration-200',
        )}
      />
    </Switch>
  );
};
